export default __webpack_public_path__ + "static/media/logo-black.7ee54719.svg";